import { useState } from "react";

// Material UI
import { Card, CardContent, CardHeader, IconButton } from "@mui/material";
import { RemoveCircleOutline, KeyboardDoubleArrowDown } from "@mui/icons-material";

const style_square = {
  padding: "6px 8px",
  font: "14px/16px Arial, Helvetica, sans-serif",
  background: "rgba(255,255,255,0.8)",
  boxShadow: "0 0 15px rgba(0,0,0,0.2)",
  borderRadius: "5px",
  marginTop: "55px",
};

const ControlFilter = ({ component, title }) => {
  const [showCard, setShowCard] = useState(true);

  return showCard ? (
    <div className="leaflet-control-container">
      <div className="leaflet-top leaflet-left">
        <div className="leaflet-control" style={style_square}>
          <Card className="card-secondary">
            <CardHeader
              title={title}
              style={{ textAlign: "center" }}
              subheader={""}
              titleTypographyProps={{ fontSize: "16px" }}
              action={
                <IconButton onClick={() => setShowCard(false)} aria-label="Minimizar">
                  <RemoveCircleOutline />
                </IconButton>
              }
            />
            <CardContent>{component}</CardContent>
          </Card>
        </div>
      </div>
    </div>
  ) : (
    <div className="leaflet-control-container">
      <div className="leaflet-top leaflet-left">
        <div className="leaflet-bar leaflet-control" style={{ marginTop: "55px" }}>
          <IconButton
            aria-label="Abrir Filtro"
            onClick={() => setShowCard(true)}
            style={{ backgroundColor: "white" }}
            sx={{
              height: "30px",
              width: "30px",
              borderRadius: "3px",
              "&:hover": { backgroundColor: "#eeeeee!important" },
            }}
          >
            <KeyboardDoubleArrowDown style={{ fontSize: 25, color: "#000" }} />
          </IconButton>
        </div>
      </div>
    </div>
  );
};

export default ControlFilter;
